import styled, { css, keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { ReactComponent as AddHospitalButton } from "../../Assets/Icons/AddHospitalButton.svg";
import Info from "../Info";
import { useState } from "react";

const scaleIn = keyframes`
  from {
    transform: scale(0.3);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const SpacerWrapper = styled.div`
  width: ${({ isVisible }) => isVisible ? `${viewSizeCalculator(3)}` : `${viewSizeCalculator(0)}`};
  height: ${({ isVisible }) => isVisible ? `${viewSizeCalculator(3)}` : `${viewSizeCalculator(3)}`};
  overflow: visible;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${() => `${viewSizeCalculator(0.4)}`};

  svg {
    cursor: pointer;
    width: ${() => `${viewSizeCalculator(2.5)}`};
    height: ${() => `${viewSizeCalculator(2.5)}`};
    pointer-events: ${({ isVisible }) => isVisible ? 'auto' : 'none'};
    opacity: ${({ isVisible }) => isVisible ? 1 : 0};
    transform: ${({ isVisible }) => isVisible ? 'scale(1)' : 'scale(0.3)'};
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    ${({ isVisible }) =>
      isVisible &&
      css`
        animation: ${scaleIn} 0.3s ease-out forwards;
      `}
  }
`;

const SpacerWithButton = ({ onClick, forceExpand }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <SpacerWrapper 
      isVisible={isHovered}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Info
        showArrow={false}
        config={{
          tooltipText: "Add Hospital",
          position: "top",
        }}
      >
        <AddHospitalButton
          onClick={() => {
            setIsHovered(false); 
            setTimeout(() => {
              onClick?.();
            }, 300);
          }}
        />
      </Info>
    </SpacerWrapper>
  );
};

export default SpacerWithButton;
